import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IState } from "./_interface";


const initialState:IState = {...defaultInitialState};
const reducers = {...defaultReducers};

export const parametersSlice = createSlice({
  name: "parameters",
  initialState,
  reducers,
});

